/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmStrukturaVlastnosti extends GContentBase<SeznamAdmStrukturaVlastnostiObj> {
        private seznamObj: SeznamAdmStrukturaVlastnostiObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmStrukturaVlastnostiObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmStrukturaVlastnosti",
                contentCaption: "jres:33000458", //RC 33000458 : Struktury vlastnost�
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_stv}"
                },
                gridSettings: {
                    columnOrder: "kod,nazev,zkratka,ixs_stv,priz_pov,dat_zmena,zmenu_provedl,priz_vycet"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmStrukturaVlastnostiObj extends GAdmSeznamBase {
        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmStrukturaVlastnosti", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmStrukturaVlastnosti",
                newRecord: isNew,
                ixs_stv: isNew == true ? null : data.ixs_stv
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenHromadnePridaniStrukturyTypObjektu: {
                    icon: "fa-link",
                    caption: "jres:33000500",
                    run: () => {
                        this.openHromadnePridaniStrukturyTypObjektu();
                    }
                },
                actOpenSeznamAdmStrukturaNavazanyObjekt: {
                    icon: "fa-link",
                    caption: "jres:33000466", //RC 33000472 : Nav�zen� objekty pro strukturu
                    run: () => {
                        this.openSeznamAdmStrukturaNavazanyObjekt()
                    }
                },
                actOpenSeznamAdmVlastnostTypDokumentu: {
                    icon: "fa-link",
                    caption: "jres:33000477", //RC 33000477 : Nav�zan� typy dokument�
                    tooltip: "jres:33000511",
                    run: () => {
                        this.openSeznamAdmVlastnostTypDokumentu()
                    }
                },
                actOpenHromadnePridaniVlastnostTypDokumentu: {
                    icon: "fa-link",
                    caption: "jres:33000513", //RC 33000513 : P�i�adit p�eddefinovan� hromadn�
                    run: () => {
                        this.openHromadnePridaniVlastnostTypDokumentu();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison", "actOpenDialogVyberovaSkupina", {
                type: "static", caption: "jres:33000138", icon: "fa-link", favorite: true, children: [
                    {
                        type: "static", caption: "jres:33000485", icon: "fa-link", children: [
                            { action: this.cnt.actions.actOpenSeznamAdmStrukturaNavazanyObjekt },
                            { action: this.cnt.actions.actOpenHromadnePridaniStrukturyTypObjektu },
                        ]
                    },
                    {
                        action: this.cnt.actions.actOpenSeznamAdmVlastnostTypDokumentu,
                        children: [
                            { action: this.cnt.actions.actOpenHromadnePridaniVlastnostTypDokumentu }
                        ]
                    }
                ]
            }]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                "actOpenSeznamAdmStrukturaVlastnostiObsah*",
                {
                    type: "static", caption: "jres:33000485", icon: "fa-link", children: [
                        { action: this.cnt.actions.actOpenSeznamAdmStrukturaNavazanyObjekt },
                        { action: this.cnt.actions.actOpenHromadnePridaniStrukturyTypObjektu },
                    ]
                },
                {
                    action: this.cnt.actions.actOpenSeznamAdmVlastnostTypDokumentu,
                    children: [
                        { action: this.cnt.actions.actOpenHromadnePridaniVlastnostTypDokumentu }
                    ]
                }
            ])
        }

        createFilterForm() {

        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmStrukturaVlastnosti.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actOpenSeznamAdmVlastnostTypDokumentu?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenSeznamAdmStrukturaVlastnostiObsah?.update({ enabled: objArr.count == 1 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.ixs_stv),
                nazev: data["nazev"]
            }
        }

        private openHromadnePridaniStrukturyTypObjektu() {
            var selectionData = this.grid.ggrid("getSelection");
            var data: Gordic.AdmIsl.Interface.GAdmVlastnostTypObjektuListDto[] = [];
            if (selectionData.length > 0) {
                selectionData.forEach((item) => {
                    data.push({
                        ixs: item["ixs_stv"],
                        ixs_txt: item["nazev"],
                        typ_vps_txt: "jres:29802692",
                        typ_vps: 10
                    })
                })
            }
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceAdmVlastnostTypObjektu"], { ID: "HromadnaOperaceAdmVlastnostTypObjektu", data: data }, "", 1000, 600)
        }

        private openHromadnePridaniVlastnostTypDokumentu() {
            var selectionData = this.grid.ggrid("getSelection");
            var data: Gordic.AdmIsl.Interface.GAdmVlastnostTypDokumentuReadDto[] = [];
            if (selectionData.length > 0) {
                selectionData.forEach((item) => {
                    data.push({
                        ixs: item["ixs_stv"],
                        typ_vps: 10
                    })
                })
            }
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceVlastnostTypDokumentu"], { ID: "HromadnaOperaceVlastnostTypDokumentu", data: data }, "", 1000, 600)
        }

        private openSeznamAdmStrukturaNavazanyObjekt() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow) {
                this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmVlastnostTypObjektu"], {
                    Id: "SeznamAdmVlastnostTypObjektu",
                    typ_vps: 10,
                    ixs: activeRow.ixs_stv
                })
            }
        }

        private openSeznamAdmVlastnostTypDokumentu() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow) {
                this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmVlastnostTypDokumentu"], {
                    Id: "SeznamAdmVlastnostTypDokumentu",
                    typ_vps: 10,
                    ixs: activeRow.ixs_stv
                })
            }
        }
    }
}
